import { uniqueId } from 'lodash';

const OPTIMISTIC_PREFIX = 'optimistic-';

type OptimisticId = `${typeof OPTIMISTIC_PREFIX}${string}`;

export const getOptimisticId = (): OptimisticId => uniqueId(OPTIMISTIC_PREFIX) as OptimisticId;

export const isOptimisticId = (id: string): id is OptimisticId => id.startsWith(OPTIMISTIC_PREFIX);
